import { createFileRoute } from '@tanstack/react-router'
import { CustomFieldTrash } from '@components'

export const Route = createFileRoute('/settings/customField_/trash/')({
  component: () => <CustomFieldTrash />,
})
